<template>
    <b-card>
        <b-card-body class="pb-0">
            <b-col class="px-0">
                <div
                    class="d-flex justify-content-between align-items-center"
                >
                        <div class="mb-25">
                            <h6 class="mb-0">
                                Number of Bookings
                            </h6>
                        </div>
                        <p class="mb-25">{{ bookingList.length }}</p>
                </div>
            </b-col>
        </b-card-body>

        <hr class="invoice-spacing" />

        <b-button
            block
            variant="primary"
            @click="$emit('submitBooking')"
        >
            Add Booking
        </b-button>
    </b-card>
</template>

<script>
import {
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BCol,
    BFormCheckbox,
    BRow,
} from 'bootstrap-vue';
import { computed, watch } from '@vue/composition-api';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import store from '@/store';
import useBookingUtils from '../composables/useBookingUtils';
import useUtils from '@/composables/useUtils';
import vSelect from 'vue-select';

export default {
    setup() {
        const { formatCurrency, formatDecimalNumber } = useUtils();
        const {
            getOfficeRate,
            getDriverRate,
            updateTaxiRate,
            getBookingTypeVariantAndName,
            storeBooking,
        } = useBookingUtils();


        const bookingList = computed(() => store.getters['booking/bookingList']);

        return {
            // Reactive
            bookingList,

            //Method
        };
    },
    components: {
        BBadge,
        BButton,
        BCard,
        BCardBody,
        BCardHeader,
        BCardTitle,
        BCol,
        BFormCheckbox,
        BRow,
        ValidationObserver,
        ValidationProvider,
        vSelect,
    },
};
</script>
